import {LIVE_UPDATE_LOADING, LIVE_UPDATE_SET} from "./liveUpdateActions";
import {GAME_SET} from "../Core/myResultsActions";

const init = {
    loading: false,
    data: null,
    included: null
};


export const liveUpdateReducer = (state = init, action) => {
    switch (action.type) {
        case GAME_SET:
            return init;
        case LIVE_UPDATE_LOADING:
            return {
                ...state, loading: true
            };
        case LIVE_UPDATE_SET:
            return {
                ...state, loading: false, ...action.payload
            };
        default:
            return state;
    }
};